const initGuaranteeCard = ($el) => {
  const countUpDuration = 1200;
  const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

  const numberElement = $el.querySelector("[data-guarantee-days]");
  const countTo = Number(numberElement?.getAttribute("data-guarantee-days"));
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const canCountUp = !!numberElement && Number.isFinite(countTo) && !prefersReducedMotion;

  // The number counts from zero the first time the card is scrolled to. A
  // merchant is free to type something that is not a number in there, and then
  // it is simply left alone.
  const countUp = () => {
    let startedAt = null;
    numberElement.textContent = "0";
    const step = (now) => {
      if (startedAt === null) startedAt = now;
      const progress = Math.min(1, (now - startedAt) / countUpDuration);
      numberElement.textContent = Math.round(countTo * easeOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  return {
    isShown: false,
    show() {
      if (this.isShown) return;
      this.isShown = true;
      if (canCountUp) countUp();
    },
  };
};

window._sections["initGuaranteeCard"] = initGuaranteeCard;
